import React from 'react'
import Footer from '../../Layout/Footer'
import Header from '../../Layout/Header'
import Sidebar from '../../Layout/Sidebar'
import Preloader from '../../Layout/Preloader';
import Select from 'react-dropdown-select';
import { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { getGroupProjectReport, getAllProjectReport } from '../../../Api/Report';
import { downloadGroupProjectReport } from "../../../Api/Project";
import { forceDownloadFile } from "../../../ApiService";

function Group_report() {
    useEffect(() => {
        document.title = "Group Report - Mindforce"
    },);

    const [lists, setLists] = useState();
    const [childProjects, setChildProjects] = useState([]);
    const [selProjectID, setProjectID] = useState();
    const [allProjSel, setAllProjectChecked] = useState(false);
    const [selChildProjIDs, setChildProjIds] = useState([]);
    const [startDate, setStartTimestamp] = useState();
    const [endDate, setEndTimestamp] = useState();

    useEffect(() => {
        getReport();
    }, []);

    useEffect(() => {
        manageChkBoxState();
    }, [selChildProjIDs]);

    const manageChkBoxState = () => {
        let chkCProj = document.getElementsByName('chkChildProjects');
        if(selChildProjIDs.length > 0){
            if(selChildProjIDs.length === childProjects.length)
            document.getElementById('allChildProject').checked = true;
            else
            document.getElementById('allChildProject').checked = false;
        }

        for(let c = 0 ; c < chkCProj.length; c++){
            if(selChildProjIDs.indexOf(chkCProj[c].value) > -1)
            chkCProj[c].checked = true;
            else
            chkCProj[c].checked = false;
        }
    }
    const setAllChildSelected = (e) => {
        let newArr = [];
        let chk = e.target;
        let chkCProj = document.getElementsByName('chkChildProjects');
        if(chk.checked){
            for(let c = 0 ; c < chkCProj.length; c++)
            newArr.push(chkCProj[c].value);
        } 
        setChildProjIds(newArr);
    }

    const setChildProjId = (e) => {
        let newArr = selChildProjIDs.slice();
        let chk = e.target;
        let prjId = chk.value;
        if(chk.checked){
            newArr.push(prjId);
        }else {
            const index = newArr.indexOf(prjId);
            if (index > -1) { // only splice array when item is found
                newArr.splice(index, 1); // 2nd parameter means remove one item only
            }
        }
        setChildProjIds(newArr);
    }

    const getReport = async() => {
        let res = await getGroupProjectReport();
        if (res.status === 1) {
            let prjList = [];

            res.payload?.map((row) => {
                    prjList.push(
                        {
                            "projectID": row.projectID,
                            "projectFullName": row.projectCode + ': ' + row.projectFullName,
                        }
                    )
                }
            )
            setLists(prjList);
        } else 
        setLists([]);
    }

    const setTimestamp = (d, t) => {
        if(t === 'startDate')
        setStartTimestamp(d);
        else if(t === 'endDate')
        setEndTimestamp(d);
    }

    const getChildReports = async(e) => {
        e.preventDefault();
        let res = await getAllProjectReport(selProjectID, startDate, endDate);
        if (res.status === 1) {
            setChildProjects(res.payload);
        } else
        setChildProjects([]);
    }

    const downloadReport = async (e) => {
        e.preventDefault();
        if(!selChildProjIDs || selChildProjIDs.length === 0){
            Swal.fire({
                icon: 'warning',
                text: 'Please select at least one project to download',
                timer: 2000,
                showConfirmButton: false
            });
            return;
        }
        // console.clear();
        // console.log(selChildProjIDs);
        let payload = {
            "filter": [
                {
                    param: "projectDetailID",
                    value: selChildProjIDs
                }
            ],
            "startDate": startDate,
            "endDate": endDate
        }
        let res = await downloadGroupProjectReport({ payload })
        if (res.status === 1)
        await forceDownloadFile(res?.payload?.reportURL)

    }

    return (
        <div>
            <Header />
            <div id="layout-wrapper">
                <div className="main-content">

                    <div className="page-content">
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <div>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a >Report</a></li>
                                                <li className="breadcrumb-item active">Group Project Report</li>
                                            </ol>
                                        </div>
                                        <h4 className="mb-sm-0">Group Project Report</h4>
                                        </div>
                                        

                                    </div>
                                </div>
                            </div>
                            {/* <!-- end page title --> */}

                            <div className="row">
                                <div className="col-xl-12 col-lg-12">
                                    <div className="card">

                                        {/* <!-- end card header --> */}

                                        <div className="card-body">
                                            <div className="report">
                                                <form >
                                                    <div className="row">
                                                   
                                                    <div className="col-md-4">
                                                            <div className="mb-3">
                                                                <label htmlFor="ForminputState" className="form-label mb-0">Group Project <span className="required_field">*</span></label>
                                                                <Select
                                                                    className="form-control"
                                                                    options={lists}
                                                                    labelField="projectFullName"
                                                                    valueField="projectID"
                                                                    searchBy="projectFullName"
                                                                    onChange={(values) => setProjectID(values[0]?.projectID)}
                                                                    placeholder="Select Project"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label htmlFor="startDate" className="form-label mb-0">From</label>
                                                                        <input type="date" className="form-control" id="startDate" max={new Date().toISOString().split("T")[0]} onChange={() => setTimestamp(document.getElementById('startDate').value, 'startDate')} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label htmlFor="endDate" className="form-label mb-0">To</label>
                                                                        <input type="date" className="form-control" id="endDate" max={new Date().toISOString().split("T")[0]} onChange={() => setTimestamp(document.getElementById('endDate').value, 'endDate')} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-lg-4">
                                                        <div className="report_btn">
                                                                <button type="submit" className="btn btn-primary" onClick={(e) => getChildReports(e)}>View</button>
                                                                <button type="submit" className="btn btn-primary mx-2" onClick={(e) => downloadReport(e)}>Download</button>


                                                            </div>
                                                        </div>
                                                        {/* <!--end col--> */}
                                                       
                                                     
                                                        {/* <!--end col--> */}
                                                       


                                                       


                                                        {/* <!--end col--> */}
                                                    </div>
                                                    {/* <!--end row--> */}
                                                    <div className='row'>
                                                        {childProjects ? (
                                                                <>
                                                                <div className='hScrollDiv'>
                                                                    <table className="table table-striped table-hover  table_client">
                                                                        {
                                                                            childProjects?.length > 0 ? (
                                                                                <>
                                                                                    <thead>
                                                                                        <tr className="bg-primary" style={{ color: "white" }}>
                                                                                            <th>S.No.</th>
                                                                                            <th>
                                                                                                <input className="form-check-input" type="checkbox" id="allChildProject" onClick={(e) => setAllChildSelected(e)} />
                                                                                            </th>
                                                                                            <th>Project Code</th>
                                                                                            <th style={{ textAlign:"left" }}>Project Name</th>
                                                                                            <th style={{ textAlign:"left" }}>Country</th>
                                                                                            <th>Complete</th>
                                                                                            <th>Terminate</th>
                                                                                            <th>OverQuota</th>
                                                                                            <th>QualityTerm</th>
                                                                                            <th>DropOut</th>
                                                                                            <th>DuplicateUser</th>
                                                                                            <th>DuplicateIP</th>
                                                                                            <th>Exclude</th>
                                                                                            <th>PSStart</th>
                                                                                            <th>PSTerminate</th>
                                                                                            <th>PSDropOut</th>
                                                                                            <th>PSOverQuota</th>
                                                                                            <th>RDFailure</th>
                                                                                            <th>TestLink</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {
                                                                                            childProjects?.map((project, i) => {
                                                                                                return (
                                                                                                    <tr key={project?.projectDetailID || i}>
                                                                                                            <td scope="row">{i + 1}</td>
                                                                                                            <td><input className="form-check-input" type="checkbox" id={"childProject-" + (i+1)} name="chkChildProjects" value={project?.projectDetailID} onClick={(e) => {setChildProjId(e)}} /></td>
                                                                                                            <td>{project?.projectDetailCode}</td>
                                                                                                            <td style={{ textAlign:"left" }}>{project?.projectDetailFullName}</td>
                                                                                                            <td style={{ textAlign:"left" }}>{project?.countryName}</td>
                                                                                                            <td>{project?.complete}</td>
                                                                                                            <td>{project?.terminate}</td>
                                                                                                            <td>{project?.overQuota}</td>
                                                                                                            <td>{project?.qualityTeam}</td>
                                                                                                            <td>{project?.dropOut}</td>
                                                                                                            <td>{project?.duplicateUser}</td>
                                                                                                            <td>{project?.duplicateIP}</td>
                                                                                                            <td>{project?.exclude}</td>
                                                                                                            <td>{project?.psStart}</td>
                                                                                                            <td>{project?.psTerminate}</td>
                                                                                                            <td>{project?.psDropOut}</td>
                                                                                                            <td>{project?.psOverQuota}</td>
                                                                                                            <td>{project?.rdFailure}</td>
                                                                                                            <td>{project?.testLink}</td>
                                                                                                    </tr>
                                                                                                );
                                                                                            })
                                                                                        }
                                                                                    </tbody>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                   <tr>
                                                                                        <td colSpan={19}>
                                                                                            <center>No project found</center>
                                                                                        </td>
                                                                                    </tr> 
                                                                                </>
                                                                            )
                                                                        }
                                                                    </table>
                                                                </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Preloader />
                                                                </>
                                                            )
                                                        }
                                                    </div>
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                {/* <!-- end col --> */}









                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Group_report